import { SEARCH_SUPPLIER_DESTINATION_MAPPING_FAILURE, SEARCH_SUPPLIER_DESTINATION_MAPPING_REQUEST, SEARCH_SUPPLIER_DESTINATION_MAPPING_RESET, SEARCH_SUPPLIER_DESTINATION_MAPPING_SUCCESS } from "redux/actions/action-type"


const initialState = {
    isSearchLoading: false,
    isSearchSuccess: false,
    isSearchFail: false,
    searchSupplierDestinationMappingResponse: {}
}

export const searchSupplierDestinationMappingReducer = (state = initialState, { type, searchSupplierDestinationMappingResponse }) => {    
    switch (type) {
        case SEARCH_SUPPLIER_DESTINATION_MAPPING_REQUEST:            
            return {
                ...state,
                isSearchLoading: true,
                isSearchSuccess: false,
                isSearchFail: false
            }
        case SEARCH_SUPPLIER_DESTINATION_MAPPING_SUCCESS:
            return {
                ...state,
                searchSupplierDestinationMappingResponse: searchSupplierDestinationMappingResponse,
                isSearchLoading: false,
                isSearchSuccess: true,
                isSearchFail: false
            }
        case SEARCH_SUPPLIER_DESTINATION_MAPPING_FAILURE:
            return {
                ...state,
                searchSupplierDestinationMappingResponse: searchSupplierDestinationMappingResponse,
                isSearchLoading: false,
                isSearchSuccess: false,
                isSearchFail: true
            }
        case SEARCH_SUPPLIER_DESTINATION_MAPPING_RESET:
            return {
                ...initialState
            }
        default:
            return {
                ...state
            }
    }
}